/* Book consultation (sections/fs-bcons-booking.liquid): date picker, time slots, details dialog, validation.
   Dates are worked out in UK time (Europe/London). Weekends, "closed dates" and today are never bookable. */
(() => {
  const TZ = 'Europe/London';
  const pad = (n) => String(n).padStart(2, '0');
  const iso = (y, m, d) => `${y}-${pad(m + 1)}-${pad(d)}`;
  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function ukToday() {
    const p = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const g = (t) => Number(p.find((x) => x.type === t).value);
    return new Date(Date.UTC(g('year'), g('month') - 1, g('day')));
  }

  function init(form) {
    if (form.dataset.fsBconsReady) return;
    form.dataset.fsBconsReady = '1';
    const cal = form.querySelector('[data-fs-bcons-cal]');
    const grid = cal.querySelector('[data-grid]');
    const monthEl = cal.querySelector('[data-month]');
    const [prev, next] = cal.querySelectorAll('.fs-bcons-cal__nav');
    const dateIn = form.querySelector('[data-fs-bcons-date]');
    const timeIn = form.querySelector('[data-fs-bcons-time]');
    const openBtn = form.querySelector('[data-fs-bcons-open]');
    const modal = form.querySelector('[data-fs-bcons-modal]');
    const summary = form.querySelector('[data-fs-bcons-summary]');
    const slots = [...form.querySelectorAll('[data-slot]')];
    const blocked = new Set((cal.dataset.blocked || '').split(/[\s,]+/).filter(Boolean));

    const today = ukToday();
    const last = new Date(today.getTime() + Number(cal.dataset.daysAhead || 90) * 864e5);
    const open = (d) => {
      const wd = d.getUTCDay();
      return d > today && d <= last && wd !== 0 && wd !== 6 && !blocked.has(iso(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
    };
    // First bookable day
    let first = new Date(today.getTime() + 864e5);
    while (!open(first) && first <= last) first = new Date(first.getTime() + 864e5);
    let sel = first <= last ? first : null;
    let view = new Date(Date.UTC((sel || today).getUTCFullYear(), (sel || today).getUTCMonth(), 1));
    let time = '';

    function render() {
      const y = view.getUTCFullYear();
      const m = view.getUTCMonth();
      monthEl.textContent = `${MONTHS[m]} ${y}`;
      prev.disabled = new Date(Date.UTC(y, m, 0)) <= today;
      next.disabled = new Date(Date.UTC(y, m + 1, 1)) > last;
      const start = new Date(Date.UTC(y, m, 1));
      const lead = (start.getUTCDay() + 6) % 7; // Monday first
      const cells = [];
      for (let i = 0; i < 42; i++) {
        const d = new Date(Date.UTC(y, m, 1 - lead + i));
        if (i >= 35 && d.getUTCMonth() !== m) break;
        const inMonth = d.getUTCMonth() === m;
        const ok = open(d) && inMonth;
        const isSel = sel && d.getTime() === sel.getTime() && inMonth;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fs-bcons-day' + (inMonth ? '' : ' fs-bcons-day--out') + (d.getTime() === today.getTime() && inMonth ? ' fs-bcons-day--today' : '') + (isSel ? ' is-selected' : '');
        b.textContent = d.getUTCDate();
        b.setAttribute('aria-label', `${DAYS[d.getUTCDay()]} ${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`);
        if (!inMonth) b.setAttribute('aria-hidden', 'true');
        if (isSel) b.setAttribute('aria-pressed', 'true');
        else if (ok) b.setAttribute('aria-pressed', 'false');
        b.disabled = !ok;
        b.tabIndex = ok ? 0 : -1;
        if (ok) b.addEventListener('click', () => { sel = d; render(); sync(); });
        cells.push(b);
      }
      grid.replaceChildren(...cells);
    }

    function label() {
      if (!sel) return '';
      return `${DAYS[sel.getUTCDay()]} ${sel.getUTCDate()} ${MONTHS[sel.getUTCMonth()]} ${sel.getUTCFullYear()}`;
    }
    function sync() {
      dateIn.value = sel ? label() : '';
      timeIn.value = time ? `${time} (UK time)` : '';
      openBtn.disabled = !(sel && time);
      if (sel && time && summary) summary.textContent = `${label()} at ${time} (UK time)`;
    }

    prev.addEventListener('click', () => { view = new Date(Date.UTC(view.getUTCFullYear(), view.getUTCMonth() - 1, 1)); render(); });
    next.addEventListener('click', () => { view = new Date(Date.UTC(view.getUTCFullYear(), view.getUTCMonth() + 1, 1)); render(); });
    slots.forEach((b) => b.addEventListener('click', () => {
      time = b.dataset.slot;
      slots.forEach((x) => { const on = x === b; x.classList.toggle('is-selected', on); x.setAttribute('aria-pressed', String(on)); });
      sync();
    }));

    // Dialog
    openBtn.addEventListener('click', () => {
      if (openBtn.disabled) return;
      if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
      document.documentElement.classList.add('fs-bcons-lock');
    });
    const close = () => { if (modal.open) modal.close(); };
    form.querySelectorAll('[data-fs-bcons-close]').forEach((b) => b.addEventListener('click', close));
    modal.addEventListener('close', () => { document.documentElement.classList.remove('fs-bcons-lock'); openBtn.focus(); });
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });

    // "Other" room and "Not sure" area
    const other = form.querySelector('[data-other]');
    const otherIn = form.querySelector('.fs-bcons-input--other');
    if (other && otherIn) other.addEventListener('change', () => { otherIn.hidden = otherIn.disabled = !other.checked; if (other.checked) otherIn.focus(); });
    const unsure = form.querySelector('[data-area-unsure]');
    const area = unsure && unsure.closest('.fs-bcons-area').querySelector('input[type=text]');
    if (unsure && area) unsure.addEventListener('change', () => {
      area.required = !unsure.checked; area.disabled = unsure.checked; area.setCustomValidity('');
      area.setAttribute('aria-required', String(!unsure.checked));
    });

    // Friendly messages
    form.querySelectorAll('[data-msg]').forEach((el) => {
      el.addEventListener('invalid', () => {
        el.setCustomValidity('');
        if (el.validity.valueMissing) el.setCustomValidity(el.dataset.msg);
        else if (el.validity.typeMismatch && el.dataset.msgType) el.setCustomValidity(el.dataset.msgType);
      });
      const clear = () => { form.querySelectorAll(`[name="${el.name}"]`).forEach((x) => x.setCustomValidity('')); };
      el.addEventListener('input', clear);
      el.addEventListener('change', clear);
    });
    form.querySelectorAll('[name="contact[Preferred colour]"], [name="contact[Underfloor heating]"]').forEach((r) =>
      r.addEventListener('change', () => form.querySelectorAll(`[name="${r.name}"]`).forEach((x) => x.setCustomValidity(''))));

    // Checkbox groups → one hidden field each; at least one ticked where required
    const groups = [...form.querySelectorAll('[data-group]')];
    groups.forEach((g) => g.addEventListener('change', () => { const c = g.querySelector('input[type=checkbox]'); if (c) c.setCustomValidity(''); }));

    form.addEventListener('submit', (e) => {
      sync();
      if (!dateIn.value || !timeIn.value) { e.preventDefault(); close(); openBtn.focus(); return; }
      for (const g of groups) {
        const boxes = [...g.querySelectorAll('input[type=checkbox]')];
        const vals = boxes.filter((c) => c.checked).map((c) => c.value);
        g.querySelector('[data-join]').value = vals.join(', ');
        boxes[0].setCustomValidity(g.hasAttribute('data-required') && !vals.length ? 'Please choose at least one option.' : '');
      }
      if (!form.checkValidity()) {
        e.preventDefault();
        const bad = form.querySelector('input:invalid, textarea:invalid, select:invalid');
        if (bad) { bad.scrollIntoView({ block: 'center' }); bad.reportValidity(); }
      }
    });

    render();
    sync();
  }

  const run = () => document.querySelectorAll('[data-fs-bcons-form]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
